import React, { FC } from 'react';
import { getFocusLabel } from '../../../training-log.helpers';
import { getFocusBadgeStyle } from '../log.helpers';

interface LogFocusBadgeProps {
  focus: string;
}

const LogFocusBadge: FC<LogFocusBadgeProps> = ({ focus }) => {
  const style = getFocusBadgeStyle(focus);
  return (
    <span className="log-focus-badge" style={{ background: style.background, color: style.color }}>
      {getFocusLabel(focus)}
    </span>
  );
};

export default LogFocusBadge;
